/* eslint-disable */

import React, { useState } from 'react';
import { convertToRaw } from 'draft-js';

import Demo3Data from './demo3data.json';
import Demo2Data from './demo2data.json';
import Demo1Data from './demo1data.json';

import { WpRichTextInput, ToolbarPlacement, OverflowBehavior } from '../';
import { WpRadioGroup, WpRadioInput } from '../../radio';
import { WpCheckbox } from '../../checkbox';
import WpTextField from '../../text-field/WpTextField';
import WpCollapsible from 'Wpds/components/collapsible/WpCollapsible';
import { WpContainer, WpContainerBody } from 'Wpds/components/container';
import WpIcon from 'Wpds/components/icon/WpIcon';
import WpButton from 'Wpds/components/button/WpButton';

const users = [
  {
    id: 103154,
    email: 'josh@9.org',
    fullName: 'joshs 9',
    firstName: 'joshs',
    lastName: '9',
    avatar: {
      color: '#F5C20D',
      initials: 'J9',
      profilePictureUrl:
        'http://localhost:5000/rails/active_storage/representations/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBBazAzIiwiZXhwIjpudWxsLCJwdXIiOiJibG9iX2lkIn19--97d1bb9b819246fd210f22193eea43a422b4f996/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaDdCam9VWTI5dFltbHVaVjl2Y0hScGIyNXpldzA2QzNKbGMybDZaVWtpRFRJMU5uZ3lOVFplQmpvR1JWUTZER2R5WVhacGRIbEpJZ3RqWlc1MFpYSUdPd2RVT2d0bGVIUmxiblJKSWd3eU5UWjRNalUyQmpzSFZEb0tjM1J5YVhCVU9oUnpZVzF3YkdsdVp5MW1ZV04wYjNKSklnbzBPakk2TUFZN0IxUTZESEYxWVd4cGRIbEpJZ2M0TlFZN0IxUTZEbWx1ZEdWeWJHRmpaVWtpQ1VwUVJVY0dPd2RVT2c5amIyeHZjbk53WVdObFNTSUpjMUpIUWdZN0IxUT0iLCJleHAiOm51bGwsInB1ciI6InZhcmlhdGlvbiJ9fQ==--9b7e7e705270d9e568ade03820f3b541acbe5ba9/mike.jpg',
      label: 'joshs 9',
    },
    confirmationSentAt: '2020-11-04T12:36:28.919-08:00',
    confirmedAt: '2020-11-04T12:36:52.137-08:00',
    zoomData: {},
    pulseMood: 'MEH_ROLLING_EYES',
    displayName: 'joshs 9',
    personId: 956624,
    personIdentifier: 'josh@9.org',
    label: 'joshs 9',
    hasSlackNotifications: null,
    role: 'manager',
    organizationRole: 'admin',
  },
  {
    id: 103155,
    email: 'billy@9.org',
    fullName: 'Billy S',
    firstName: 'Billy',
    lastName: 'S',
    avatar: {
      color: '#D41C8A',
      initials: 'BS',
      profilePictureUrl: null,
      label: 'Billy S',
    },
    confirmationSentAt: '2020-11-04T12:37:38.580-08:00',
    confirmedAt: '2020-11-04T12:38:10.634-08:00',
    zoomData: {},
    pulseMood: null,
    displayName: 'Billy S',
    personId: 956625,
    personIdentifier: 'billy@9.org',
    label: 'Billy S',
    hasSlackNotifications: null,
    role: 'full_member',
    organizationRole: 'admin',
  },
  {
    avatar: { color: '#5C6ECB', initials: 'DM', profilePictureUrl: null, label: 'dj matthew' },
    confirmationSentAt: '2020-11-04T12:50:30.110-08:00',
    confirmedAt: '2020-11-04T12:51:04.663-08:00',
    displayName: 'dj m',
    email: 'dj@9.org',
    firstName: 'dj',
    fullName: 'dj matthew',
    hasSlackNotifications: null,
    id: 103156,
    label: 'dj matthew',
    lastName: 'matthew',
    organizationRole: 'admin',
    personId: 956626,
    personIdentifier: 'dj@9.org',
    pulseMood: null,
    role: 'full_member',
    type: 'user',
    zoomData: {},
  },
  {
    avatar: { color: '#D41C8A', initials: 'JJ', profilePictureUrl: null, label: 'Joel Johnson' },
    confirmationSentAt: '2020-11-09T10:50:15.181-08:00',
    confirmedAt: '2020-12-07T09:10:14.547-08:00',
    displayName: 'Joel J',
    email: 'joel@9.org',
    firstName: 'Joel',
    fullName: 'Joel Johnson',
    hasSlackNotifications: null,
    id: 103157,
    label: 'Joel Johnson',
    lastName: 'Johnson',
    organizationRole: 'regular_user',
    personId: 956627,
    personIdentifier: 'joel@9.org',
    pulseMood: null,
    role: 'full_member',
    type: 'user',
    zoomData: {},
  },
  {
    avatar: { color: '#B7D210', initials: 'VH', profilePictureUrl: null, label: 'Victor Hugo' },
    confirmationSentAt: '2020-11-18T17:04:45.494-08:00',
    confirmedAt: '2020-12-02T20:43:37.833-08:00',
    displayName: 'Victor H',
    email: 'victor@9.org',
    firstName: 'Victor',
    fullName: 'Victor Hugo',
    hasSlackNotifications: null,
    id: 103165,
    label: 'Victor Hugo',
    lastName: 'Hugo',
    organizationRole: 'regular_user',
    personId: 956635,
    personIdentifier: 'victor@9.org',
    pulseMood: null,
    role: 'full_member',
    type: 'user',
    zoomData: {},
  },
];

const RichTextDocs = () => {
  const Debugger = ({ editorState }) => {
    // try (editorState.getCurrentContent()) {
    //   return null;
    // } catch {
    try {
      editorState.getCurrentContent();
    } catch (e) {
      return null;
    }
    const [isDebugOpen, setIsDebugOpen] = useState(false);

    const renderContentAsRawJs = () => {
      const contentState = editorState.getCurrentContent();
      const raw = convertToRaw(contentState);

      return JSON.stringify(raw, null, 2);
    };

    return (
      <div className="mt-4">
        <WpButton size="sm" variant="tertiary" onClick={() => setIsDebugOpen(!isDebugOpen)}>
          editorState debugger
          <WpIcon name={isDebugOpen ? 'angle-down' : 'angle-right'} />
        </WpButton>
        <WpCollapsible open={isDebugOpen}>
          <WpContainer>
            <WpContainerBody>{renderContentAsRawJs()}</WpContainerBody>
            {/* <WpContainerBody>{JSON.stringify(editorState, null, 2)}</WpContainerBody> */}
          </WpContainer>
        </WpCollapsible>
      </div>
    );
  };

  const DemoShowingOptions = () => {
    const [editorState, setEditorState] = useState('test state http://localhost:5000/wpds/rich-text');
    const [isReadOnly, setIsReadOnly] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);
    const [showToolbar, setShowToolbar] = useState(true);
    const [toolbarPlacement, setToolbarPlacement] = useState('top' as ToolbarPlacement);
    const [overflowBehavior, setOverflowBehavior] = useState('grow' as OverflowBehavior);
    const [height, setHeight] = useState('150px');
    const [isBordered, setIsBordered] = useState(true);
    return (
      <>
        <h5>showing off options</h5>

        <div className="my-3" style={{ width: '300px' }}>
          <WpCheckbox
            id="is-read-only"
            label="readOnly"
            checked={isReadOnly}
            onChange={() => setIsReadOnly(!isReadOnly)}
          />
          <WpCheckbox
            id="is-disabled"
            label="disabled"
            checked={isDisabled}
            onChange={() => setIsDisabled(!isDisabled)}
          />
          <WpCheckbox
            id="show-border"
            label="options.showBorder"
            checked={isBordered}
            onChange={() => setIsBordered(!isBordered)}
          />
          <WpCheckbox
            id="show-toolbar"
            label="options.showToolbar"
            checked={showToolbar}
            onChange={() => setShowToolbar(!showToolbar)}
          />
          <p style={{ marginBottom: 0, marginTop: '0.75rem' }}>options.toolbarPlacement</p>
          <WpRadioGroup
            id="toolbar-placement"
            label="Change toolbar placement"
            direction="horizontal"
            defaultValue="top"
            labelHidden={true}
            onChange={value => setToolbarPlacement(value as ToolbarPlacement)}
          >
            <WpRadioInput id="top" label="Top" value="top" />
            <WpRadioInput id="bottom" label="bottom" value="bottom" />
          </WpRadioGroup>
          <p style={{ marginBottom: 0, marginTop: '0.75rem' }}>options.overflowBehavior</p>
          <WpRadioGroup
            id="overflow-behavior"
            label="Overflow Behavior"
            direction="horizontal"
            defaultValue="grow"
            labelHidden={true}
            onChange={value => setOverflowBehavior(value as OverflowBehavior)}
          >
            <WpRadioInput id="grow" label="Grow" value="grow" />
            <WpRadioInput id="scroll" label="Scroll" value="scroll" />
          </WpRadioGroup>
          <div style={{ marginBottom: 0, marginTop: '0.75rem' }}>
            <WpTextField id="height" label="Height" value={height} onChange={setHeight} />
          </div>
        </div>
        <WpRichTextInput
          value={editorState}
          placeholder="Enter some cool content here"
          height={height}
          readOnly={isReadOnly}
          disabled={isDisabled}
          onChange={setEditorState}
          options={{
            showToolbar,
            toolbarPlacement: toolbarPlacement,
            showBorder: isBordered,
            overflowBehavior: overflowBehavior,
          }}
          autoFocus
          qaTest="rich-text-input-test"
          mentionUsers={users}
        />
        <Debugger editorState={editorState} />
      </>
    );
  };
  const Demo1 = () => {
    const [editorState, setEditorState] = useState('');
    return (
      <>
        <h5 className="mt-5">no value passed in</h5>
        <WpRichTextInput
          onChange={setEditorState}
          placeholder="Enter some cool content here"
          height="225px"
          mentionUsers={users}
        />
        <Debugger editorState={editorState} />
      </>
    );
  };
  const Demo2 = () => {
    const [editorState, setEditorState] = useState('This value is a plain string');
    return (
      <>
        <h5 className="mt-5">string passed in as value</h5>
        <WpRichTextInput
          value="This value is a plain string"
          onChange={setEditorState}
          placeholder="enter text"
          mentionUsers={users}
        />
        <Debugger editorState={editorState} />
      </>
    );
  };
  const Demo3 = () => {
    const [editorState, setEditorState] = useState(Demo2Data);
    return (
      <>
        <h5 className="mt-5">raw contentState object as value</h5>
        <WpRichTextInput
          value={editorState}
          onChange={setEditorState}
          placeholder="enter text"
          options={{ toolbarPlacement: 'bottom' }}
          mentionUsers={users}
        />
        <Debugger editorState={editorState} />
      </>
    );
  };
  const Demo4 = () => {
    const [editorState, setEditorState] = useState(JSON.stringify(Demo3Data));
    return (
      <>
        <h5 className="mt-5">json string as value</h5>
        <WpRichTextInput value={editorState} onChange={setEditorState} placeholder="enter text" mentionUsers={users} />
        <Debugger editorState={editorState} />
      </>
    );
  };

  const Demo5 = () => {
    const [editorState, setEditorState] = useState(Demo1Data);
    return (
      <>
        <h5 className="mt-5">Test</h5>
        <WpRichTextInput
          value={editorState}
          onChange={setEditorState}
          placeholder="cool placeholder text"
          mentionUsers={users}
        />
        <Debugger editorState={editorState} />
      </>
    );
  };

  return (
    <>
      <DemoShowingOptions />
      <Demo1 />
      <Demo2 />
      <Demo3 />
      <Demo4 />
      <Demo5 />
    </>
  );
};

export default RichTextDocs;
